import ReservationCardDispatcher from '../dispatcher/ReservationCardDispatcher'
import ReservationCardConstants from '../constants/ReservationCardConstants'

var ReservationCardActions = {
  /**
  * Initialize the CardStore
  *
  * @param {object} opts
  */

  init: function (opts) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.INIT,
      opts: opts
    });
  },

  save: function() {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.SAVE
    });
  },

  setActiveTab: function(tab) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.SET_ACTIVE_TAB,
      tab: tab
    });
  },

  setSubmitButton: function(submitButton) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.SET_SUBMIT_BUTTON,
      submitButton: submitButton
    });
  },

  setValue: function(name, value) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.SET_VALUE,
      name: name,
      value: value,
    })
  },

  updateNoteCount: function(count) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.UPDATE_NOTE_COUNT,
      count: count,
    })
  },

  updateServiceRequestCount: function(count) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.UPDATE_SERVICE_REQUEST_COUNT,
      count: count,
    })
  },

  refresh: function (opts) {
    ReservationCardDispatcher.dispatch({
      action: ReservationCardConstants.REFRESH,
      opts: opts,
    });
  },

};
export default ReservationCardActions;